import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { apiGet } from '@/api/api'

// 위치 정보 인터페이스
export interface IUserPosition {
  order: number
  latitude: number
  longitude: number
  accuracy: number
  timestamp: string
}

// 회원의 특정 날짜 또는 오늘 위치 정보 조회 API
export const apiGetUserDailyPosition = async (userId: number, date?: string) => {
  // 엔드포인트 URL
  let url = `/protectee/${userId}/daily-position`;
  if (date) {
    url += `?date=${date}`;
  }
  
  // apiGet을 사용하여 요청 (토큰 갱신 로직 포함됨)
  const response = await apiGet<IUserPosition[]>(url);
  
  return response;
}

// 위치 정보 쿼리 훅
const useQueryGetUserDailyPosition = (userId: number, date?: string) => {
  return useQuery({
    enabled: userId > 0,
    queryKey: QueryCacheKeys.user.getUserDailyPosition(userId, date),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 30000, // 30초간 캐시 유지
    queryFn: async () => {
      try {
        const response = await apiGetUserDailyPosition(userId, date);
        return Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        return [];
      }
    }
  })
}

export default useQueryGetUserDailyPosition 